import {
  RepairTicketStatuses, VEHICLE_MAINTENANCE, VEHICLE_MISSING, vehicleTypeNameValues,
} from '../utils';

const OPERATOR = 'operator';
const MARKETS = 'markets';
const VEHICLES = 'vehicles';
const VEHICLE_TRIPS = 'trips';
const REPAIRS = 'repairs';
const DASHBOARD = 'dashboard';

export const MARKET_ID_PARAM = ':marketId';
export const VEHICLE_ID_PARAM = ':vehicleId';

export const SORT_URL_NAME = 'sort';
export const SORT_DIR_URL_NAME = 'sortDir';
export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
export const VEHICLE_STATUS_URL_NAME = 'status';
export const VEHICLE_TYPE_URL_NAME = 'type';
export const VEHICLE_BRAND_URL_NAME = 'brand';
export const VEHICLE_BATTERY_GT_URL_NAME = 'batteryLevelGt';
export const VEHICLE_BATTERY_LT_URL_NAME = 'batteryLevelLt';
export const VEHICLE_LAST_ACTIVITY_GT_URL_NAME = 'lastActivityGt';
export const VEHICLE_LAST_ACTIVITY_LT_URL_NAME = 'lastActivityLt';
export const RECURRING_URL_NAME = 'recurrence';
export const PRIORITY_URL_NAME = 'priority';
export const REPAIR_STATUS = 'status'; // RepairTicketStatuses
export const REPAIR_SEVERITY = 'severity';
export const REPAIR_VEHICLE_TYPE = 'type';
export const SERVICE_VEHICLE_TYPE = 'type';

export const GET_MARKET_OVERVIEW = () => `/${OPERATOR}/${MARKETS}`;
export const GET_MARKET_DETAIL = (marketId) => `/${OPERATOR}/${MARKETS}/${marketId}`;
export const GET_MARKET_VEHICLES = (marketId) => `/${OPERATOR}/${MARKETS}/${marketId}/${VEHICLES}`;
export const GET_MARKET_VEHICLE = (marketId, vehicleId) => `/${OPERATOR}/${MARKETS}/${marketId}/${VEHICLES}/${vehicleId}`;
export const GET_MARKET_VEHICLE_TRIPS = (marketId, vehicleId) => `/${OPERATOR}/${MARKETS}/${marketId}/${VEHICLES}/${vehicleId}/${VEHICLE_TRIPS}`;
export const GET_MARKET_REPAIRS = (marketId) => `/${OPERATOR}/${MARKETS}/${marketId}/${REPAIRS}`;
export const GET_MARKET_REPAIR = (marketId, repairTicketId) => `/${OPERATOR}/${MARKETS}/${marketId}/${REPAIRS}/${repairTicketId}`;
export const GET_DASHBOARD = (marketId) => `/${OPERATOR}/${MARKETS}/${marketId}/${DASHBOARD}`;

function isValidVehicleType(type) {
  const foundType = vehicleTypeNameValues.find((typeName) => typeName === type);
  return foundType !== undefined;
}

export function getMarketVehicleClickHandler(history, marketId) {
  return () => {
    const baseUrl = GET_MARKET_VEHICLES(marketId);
    history.push(baseUrl);
  };
}

export function getMissingVehicleClickHandler(marketId, history, type) {
  return () => {
    let baseVehicleUrl = GET_MARKET_VEHICLES(marketId);
    baseVehicleUrl = `${baseVehicleUrl}?`;
    if (isValidVehicleType(type)) {
      baseVehicleUrl = `${baseVehicleUrl}&${VEHICLE_TYPE_URL_NAME}=${type}`;
    }
    const missingVehicleUrl = `${baseVehicleUrl}&${VEHICLE_STATUS_URL_NAME}=${VEHICLE_MISSING}`;
    history.push(missingVehicleUrl);
  };
}

export function getMaintenanceVehicleClickHandler(marketId, history, type) {
  return () => {
    let baseVehicleUrl = GET_MARKET_VEHICLES(marketId);
    baseVehicleUrl = `${baseVehicleUrl}?`;
    if (isValidVehicleType(type)) {
      baseVehicleUrl = `${baseVehicleUrl}&${VEHICLE_TYPE_URL_NAME}=${type}`;
    }
    const missingVehicleUrl = `${baseVehicleUrl}&${VEHICLE_STATUS_URL_NAME}=${VEHICLE_MAINTENANCE}`;
    history.push(missingVehicleUrl);
  };
}

export function getOpenRepairsClickHandler(marketId, vehicleType, history) {
  return () => {
    let baseUrl = GET_MARKET_REPAIRS(marketId);
    baseUrl = `${baseUrl}?`;
    let repairUrl = `${baseUrl}&${REPAIR_STATUS}=${RepairTicketStatuses.OPEN}&${REPAIR_VEHICLE_TYPE}=${vehicleType}`;
    if (vehicleType) repairUrl = `${repairUrl}&${REPAIR_VEHICLE_TYPE}=${vehicleType}`;
    history.push(repairUrl);
  };
}

export default {
  MARKET_ID_PARAM,
  VEHICLE_ID_PARAM,
  GET_MARKET_OVERVIEW,
  GET_MARKET_DETAIL,
  GET_MARKET_VEHICLES,
  GET_MARKET_VEHICLE,
  GET_MARKET_REPAIRS,
  GET_MARKET_REPAIR,
  GET_DASHBOARD,
};
